 /* eslint-disable angular/di */
angular
  .module('fca-used')
  .config(['energyLabelConfigProvider', function (energyLabelConfigProvider) {
    energyLabelConfigProvider.setEnergyClassList(['A+', 'A', 'B', 'C', 'D', 'E', 'F', 'G']);
  }]);
 /* eslint-enable angular/di */
